// AtrWidget/AtrCache.js
// Normal Cache — CacheBase2, singleton export (Engine Pattern rk=f03ae8b6).
// rk = Sid (BE-side change, per Kimmie 2026-09-07) — self-limiting, exactly 1 entry per
// asset always. No date component in rk, so unlike Sma200Cache (rk=896be0200668464897d0dc11b9ae1f47)
// this does NOT grow unbounded on daily RMQ pushes; a new push for the same asset just
// overwrites its one entry.
import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'AtrCache';

class AtrCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }
}

const atrCache = new AtrCache();
export default atrCache;
